var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import WalletConnectProvider from "@walletconnect/ethereum-provider";
import { ADAPTER_EVENTS, ADAPTER_STATUS, BaseAdapter, log, SUPPORTED_ADAPTERS, } from "../base";
class WalletConnectV2Adapter extends BaseAdapter {
    constructor(options) {
        if (!options.chainId) {
            options.chainId = "0x1";
        }
        super(options);
        this.name = SUPPORTED_ADAPTERS.WALLET_CONNECT_V2;
        this.status = ADAPTER_STATUS.NOT_READY;
        this.wcProvider = null;
        this.adapterOptions = Object.assign({}, options);
    }
    get chainId() {
        if (this.wcProvider) {
            return `0x${this.wcProvider.chainId.toString(16)}`;
        }
        return null;
    }
    get connected() {
        return !!this.wcProvider.session;
    }
    get provider() {
        if (this.status === ADAPTER_STATUS.CONNECTED && this.wcProvider) {
            // @ts-ignore
            return this.wcProvider;
        }
        return null;
    }
    _init(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            this.wcProvider = yield WalletConnectProvider.init({
                projectId: this.adapterOptions.projectId,
                chains: [1],
                optionalChains: [5],
                showQrModal: true,
                optionalMethods: [
                    "eth_signTypedData",
                    "eth_signTypedData_v4",
                    "eth_sign",
                ],
            });
            this.emit(ADAPTER_EVENTS.READY, SUPPORTED_ADAPTERS.WALLET_CONNECT_V2);
            this.status = ADAPTER_STATUS.READY;
            log.debug("initializing wallet connect V2 adapter");
            if (options.autoConnect) {
                log.debug("walletconnect V2 auto connect");
                if (this.connected) {
                    log.debug("walletconnect V2 session already connected");
                    try {
                        yield this.connect();
                    }
                    catch (err) {
                        this.status = ADAPTER_STATUS.READY;
                        this.emit(ADAPTER_EVENTS.CACHE_CLEAR);
                    }
                }
                else {
                    this.status = ADAPTER_STATUS.READY;
                    this.emit(ADAPTER_EVENTS.CACHE_CLEAR);
                }
            }
        });
    }
    _connect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wcProvider)
                throw Error("Wallet adapter is not ready yet");
            this.status = ADAPTER_STATUS.CONNECTING;
            this.emit(ADAPTER_EVENTS.CONNECTING, {
                adapter: SUPPORTED_ADAPTERS.WALLET_CONNECT_V2,
            });
            try {
                if (!this.wcProvider.session) {
                    yield this.wcProvider.connect();
                }
                // If session exists and chains are authorized, enable provider for required chain
                const accounts = yield this.wcProvider.enable();
                yield this.postConnected(accounts[0]);
                if (!this.provider)
                    throw Error("Failed to connect with provider");
                return this.provider;
            }
            catch (error) {
                // ready again to be connected
                this.status = ADAPTER_STATUS.READY;
                this.emit(ADAPTER_EVENTS.ERRORED, error);
                log.error(`Failed to login with walletconnect V2 wallet: ${error}`);
                throw Error("Failed to login with walletconnect V2 wallet");
            }
        });
    }
    _disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wcProvider || !this.connected)
                throw Error("Not connected with wallet");
            yield this.wcProvider.disconnect();
            // ready to connect again
            this.status = ADAPTER_STATUS.READY;
            this.emit(ADAPTER_EVENTS.DISCONNECTED);
        });
    }
    _switchChain(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            yield this.wcProvider.request({
                method: "wallet_switchEthereumChain",
                params: [
                    {
                        chainId,
                    },
                ], // chainId must be in hexadecimal numbers
            });
            this.setAdapterSettings({
                chainId,
            });
        });
    }
    postConnected(address) {
        return __awaiter(this, void 0, void 0, function* () {
            // Subscribe to accounts change
            this.wcProvider.on("accountsChanged", (accounts) => {
                log.debug(`accountsChanged: ${accounts}`);
                this.emit(ADAPTER_EVENTS.ACCOUNT_CHANGED, { accounts });
            });
            // Subscribe to chainId change
            this.wcProvider.on("chainChanged", (chainId) => {
                log.debug(`chainChanged: ${chainId}`);
                this.emit(ADAPTER_EVENTS.CHAIN_CHANGED, {
                    chainId,
                });
            });
            this.status = ADAPTER_STATUS.CONNECTED;
            this.emit(ADAPTER_EVENTS.CONNECTED, {
                adapter: SUPPORTED_ADAPTERS.WALLET_CONNECT_V2,
                status: {
                    chainId: `0x${this.wcProvider.chainId.toString(16)}`,
                    address,
                },
            });
        });
    }
}
export { WalletConnectV2Adapter };
//# sourceMappingURL=walletConnectV2Adapter.js.map